import { BaseActivityBasicModel } from '../base-activity-basic.model';

export interface EmailCampaignActivityBasicModel extends BaseActivityBasicModel {}
